import { FormField, Textarea } from '@ds/forms';
import type { Fatura, TipoDeCredito } from '@/data/tipos';

/** Todo ato do operador que muda o que a clínica tem pede motivo — o banco recusa menos de 10 caracteres. */
export const MOTIVO_MINIMO = 10;

export function motivoValido(motivo: string): boolean {
    return motivo.trim().length >= MOTIVO_MINIMO;
}

/** "1.250,50" e "1250.5" viram 125050. Vazio ou ilegível vira nulo, e nulo não é zero. */
export function centavosDoTexto(texto: string): number | null {
    const limpo = texto.trim().replace(/[^\d,.-]/g, '');
    if (!limpo) return null;
    const normal = limpo.includes(',') ? limpo.replace(/\./g, '').replace(',', '.') : limpo;
    const n = Number(normal);
    return Number.isFinite(n) ? Math.round(n * 100) : null;
}

export const SITUACAO_DA_FATURA: Record<Fatura['situacao'], { rotulo: string; tom: 'success' | 'warning' | 'danger' | 'neutral' }> = {
    paga: { rotulo: 'Paga', tom: 'success' },
    aberta: { rotulo: 'Em aberto', tom: 'warning' },
    vencida: { rotulo: 'Vencida', tom: 'danger' },
    estornada: { rotulo: 'Estornada', tom: 'neutral' },
};

export const TIPOS_DE_CREDITO: { value: TipoDeCredito; label: string }[] = [
    { value: 'cortesia', label: 'Cortesia' },
    { value: 'compensacao', label: 'Compensação' },
    { value: 'migracao', label: 'Migração de plano' },
    { value: 'indicacao', label: 'Indicação' },
    { value: 'acordo', label: 'Acordo comercial' },
];

export function quandoCompleto(iso: string | undefined): string {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', dateStyle: 'short', timeStyle: 'short' });
}

/** O campo de motivo, igual em todo modal do operador. */
export function CampoDeMotivo({ id, valor, onChange, rotulo = 'Motivo', dica }: {
    id: string;
    valor: string;
    onChange: (valor: string) => void;
    rotulo?: string;
    dica?: string;
}) {
    return (
        <FormField
            label={rotulo} htmlFor={id} required
            hint={dica ?? `Fica no histórico da clínica e no log de auditoria. Escreva ao menos ${MOTIVO_MINIMO} caracteres.`}
        >
            <Textarea id={id} rows={3} value={valor} onChange={onChange} />
        </FormField>
    );
}
